const HOUR_MS = 60 * 60 * 1000;

export const MIGRATION_CONSENT_DISMISS_WINDOWS_MS = [24 * HOUR_MS, 48 * HOUR_MS, 72 * HOUR_MS];

export function isMigrationConsentSnoozed(count: number, lastDismissedAtMs: number, nowMs: number): boolean {
    if (count <= 0) {
        return false;
    }

    const index = Math.min(count, MIGRATION_CONSENT_DISMISS_WINDOWS_MS.length) - 1;
    return nowMs - lastDismissedAtMs < MIGRATION_CONSENT_DISMISS_WINDOWS_MS[index];
}
